import { AfterContentInit, Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { USERACTIONS, UserActions, RouteInfo, ROUTES_1 } from 'projects/shared/src/lib/models/IMenuItem';
import { SquirrelSessionRequest } from 'projects/shared/src/lib/models/SquirrelSession';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { BaseService } from 'projects/shared/src/lib/services/base.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { EventsService } from 'projects/shared/src/lib/services/events.service';
import { LegacySquirrelService } from 'projects/shared/src/lib/services/legacy-squirrel.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

declare const $: any;

@Component({
  selector: 'squirrel-side-nav',
  templateUrl: './squirrel-side-nav.component.html',
  styleUrls: ['./squirrel-side-nav.component.scss']
})
export class SquirrelSideNavComponent  extends BaseService implements OnInit, AfterContentInit{

  isLoading = false;
  //tenantForm!: FormGroup;

  isAuthenticated!: boolean;

  //tenants: TenantDto[] = [];
  defaultTenantdb!: string;
  //currentTenantdb!:string;
  routeInfo: RouteInfo[] = []

  public showTenantSelect: boolean = false;
  menuItems: RouteInfo[] = [];

  //public avatar: string = './assets/img/avatar-emty.png';
  public squirreltext: string = './assets/img/squirreltext.png';
  items: UserActions[] = [];

  squirrelSessionRequest!: SquirrelSessionRequest;
  projectUrl: string = '';
  projectName: string = '';

  userNavRoles:string[] = [];

  _adminRole!: string;
  //_projectRole!: string;
  //_dbRole!: string;
  //_tenant!: string;
  //_tenantmode!: string;
  //_usersRole!: string;
  _addProjectRole!: string;
  _addUserRole!: string;
  _db!: string;
  _tenantName!: string;
  _tenantNameCheck!: string;

  _userRoles!: string[];
  _SystemManagerAbbrev!: string;
  _SMmode!: boolean;

  //test
  _manageUsers: boolean = false;
  _manageProjects: boolean = false;

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    public translate: TranslateService,
    private dataSharingService: DataSharingService,
    private legacySquirrelService: LegacySquirrelService,
    private notificationService: NotificationService,
    private oauthService: OAuthServiceService,
    private projectService: ProjectService,
    private tenantService: TenantService,
    private eventsService: EventsService
  ) {
    super();
  }

  ngOnInit() {
    var self = this;
    if (this.tenantService.SMmode || self.tenantService.currentTenantName == self.tenantService.SystemManagerAbbreviation){
      self._SMmode = this.tenantService.SMmode;
      self._tenantNameCheck = self.tenantService.SystemManagerAbbreviation;
    }
    self._SystemManagerAbbrev = this.tenantService.SystemManagerAbbreviation;
    self._userRoles = [];
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //console.log("------> squirrel-side-nav userData: ", data);
          var userRoles = data.role as Array<string>;
          if (userRoles != null && userRoles.length > 1){
            userRoles.forEach((role: string) =>{
              if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") self._userRoles.push(role);
            })
          }
          self.isAuthenticated = true;
        }
      }
    });
    //this._tenantName = this.tenantService.tempTenantName;
    this._tenantName = this.tenantService.currentTenantName;
    console.log("------> squirrel-side-nav tenantName: ", this._tenantName);
    console.log("------> squirrel-side-nav tempTenantName: ", this.tenantService.tempTenantName);
    if (this._tenantName != null){
    // force creating new token? no, cause temp. tokenMap is empty ==> new token
      this.tenantService.getToken(this._tenantName, false).subscribe({
        next: (token) => {
          var tenantRoles = this.tenantService.getTenantRoles(token);
          console.log("------> tenant roles: ", tenantRoles);
          if (tenantRoles != null){
            tenantRoles.forEach((role: string)=> {
              if (role != "" && !this._userRoles.includes(role)) self._userRoles.push(role);
              // test
              if (role == 'MANAGE_USERS' || role == 'TENANTADMIN') self._manageUsers = true;
              if (role == 'MANAGE_PROJECTS' || role == 'TENANTADMIN') self._manageProjects = true;
            });
          }
          //console.log("------> user roles: ", self._userRoles);
        }
      });
    }
    
    this.items = USERACTIONS;
    //this.menuItems = ROUTES.filter(menuItem => menuItem);

    this.eventsService.defaultTenantdbChanged.subscribe((defaultTenantdb: string) => this.defaultTenantdb = defaultTenantdb);
    //this.eventsService.currentTenantDbChnaged.subscribe((currentTenantdb: string) => this.currentTenantdb = currentTenantdb);
    this.eventsService.menuItemsChanged.subscribe((menuItems: RouteInfo[]) => this.menuItems = menuItems);
    //this.eventsService.currentTenantNameChanged.subscribe((currentTenantName: string) => {this._tenantName = currentTenantName});

    if (!this._tenantName) {
      this.router.navigate(['/', 'check-userlogin']);
    }

    if (this.isAuthenticated) {
      // To check for a "truthy value" or  "falsy value"
      if (!this.tenantService.defaultTenantdb) {
        this.tenantService.getDefaultRouteInfo(this._db);
      }
      else {
        this.defaultTenantdb = this.tenantService.defaultTenantdb;
        this.menuItems = this.tenantService.menuItems;
      }
    }
  }

  ngAfterContentInit(): void {

    if (!this.defaultTenantdb) {
      this.defaultTenantdb = this.tenantService.defaultTenantdb;
    }

    this.dataSharingService.activeProjectName.subscribe({
      next: (pname: string) => {
        this.projectName = pname.replace("_", " ");
      }
    });

    this.dataSharingService.squirrelSessionRequestState$.subscribe({
      next: (squirrelSessionRequest: SquirrelSessionRequest) => {
        this.squirrelSessionRequest = squirrelSessionRequest;
        console.log(squirrelSessionRequest)
      }
    });
  }


  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  createSession(squirrelSessionRequest: SquirrelSessionRequest) {
    squirrelSessionRequest.languageKey = localStorage.getItem('app_lang') as string;

    this.projectService.createProjectSession(squirrelSessionRequest).subscribe({
      next: (sqSession) => {
        this.notificationService.success(`${this.translate.data["CREATESQUIRRELSESSION"]}`, `${this.translate.data["SQUIRRELSESSIONCREATED"]}`);
        this.projectUrl = '';
        window.open(`${sqSession.legacySquirrelUrl}`, '_blank');
      },
      error: () => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["CREATESQUIRRELSESSIONERROR"]}`)
      }
    })
  }

  navigateToLink(): void {
    // window.open("https://localhost:44303/", '_blank');
    window.open(`${this.identityAdmin}`, '_blank');
  }
}
